import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, PERMISSIONS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allPermission',
  url: `${PERMISSIONS_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
